import React, {Component} from 'react';
import {ProviderImage} from '../../../components';

class MediaTask extends Component {
  render(){
    const {media} = this.props;
    return(
      <div className="container row justify-content-center">
        <div className="col-6 align-self-center">
          <div className="mb-2">
            <span style={{cursor:"pointer"}}>
              <ProviderImage provider={media.contentProvider} onClick={() => window.open(media.listingUrl, "_blank")}/>
            </span>
          </div>
          <img src={media.imageUrl} style={{width: '100%'}} />
          <br/>
          <div className="text-center mt-4">
            {media.caption}
          </div>
        </div>
      </div>
    );
  }
}

export default MediaTask;
